import { useQuery } from "@apollo/client";
import type { GbpMediaItem } from "@/gql/graphql";
import { GBP_LIST_MEDIA_QUERY } from "@/graphql/google-business";
import { useSalonStore } from "@/lib/store/salon";

export function useGbpMedia() {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id;

  const { data, loading } = useQuery(GBP_LIST_MEDIA_QUERY, {
    variables: { salonId: salonId ?? "" },
    skip: !salonId,
    errorPolicy: "ignore",
    fetchPolicy: "cache-and-network",
  });

  const media: GbpMediaItem[] = data?.gbpListMedia ?? [];
  const firstPhotoUrl = media[0]?.thumbnailUrl ?? media[0]?.googleUrl ?? null;
  const secondPhotoUrl = media[1]?.thumbnailUrl ?? media[1]?.googleUrl ?? firstPhotoUrl;

  return { media, firstPhotoUrl, secondPhotoUrl, loading } as const;
}
